module.exports = "/Users/modetojoy/work/10gen/compass-server-version/lib/assets/images/fontawesome-webfont__2Vqpe.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/font-awesome/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = 17
// module chunks = 0